<template>
  <div>
    <div class="topbar">
      <i @click="goIndex"></i>
      <div class="mainBox1 clearfix">
        <div class="changeLangBtn" @click.stop="moreLang()">
          {{ $t("language") }}
          <em class="iconfont icon-een"></em>
          <ul
            v-show="changeLangBox"
            class="chooseLangUl"
          >
            <li
              v-for="(item, index) in langList"
              class="chooseLangUlli"
              :key="index"
              @click="setLanguage(item.id)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="settingBtn" @click.stop="setting()">
          <!-- {{$t("nav_setting")}} -->
          {{ name ? name : names }}
          <em class="iconfont icon-een"></em>
          <ul v-show="settingBoxVis" class="chooseLangUl chooseLangUls">
            <li @click="goIndex">{{ $t("myHome") }}</li>
            <li @click="toMyAccount">{{ $t("setting_1") }}</li>
            <li @click="logOut">{{ $t("setting_2") }}</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="mainBox">
      <!-- 页面标题 -->
      <div class="forgetPsd1">{{ $t("myPageTitle") }}</div>
      <!-- 四个主要指标 -->
      <div class="journeyBox">
        <div class="tagButtonFlex">
          <div>
            <button type="button" class="tagButton" :class="{activeTagButton: switchFlag == 0}" @click="switchMode(0)" >{{ $t("myJourneyBtn") }}</button>
            <button type="button" class="tagButton" :class="{activeTagButton: switchFlag == 2}" @click="switchMode(2)" >{{ $t("myLevelMatchBtn") }}</button>
            <button type="button" class="tagButton" :class="{activeTagButton: switchFlag == 1}" @click="switchMode(1)">{{ $t("myGlobalMatchBtn") }}</button>
          </div>
          <div class="ohcBtn">
            <img
              v-if="ohcCert === true && $i18n.locale === 'zh'"
              src="~@/assets/images/event/oneHourCode/cert-dl-btn-C.png"
              @click="oneHourCertDownload()"
            />
            <img
              v-if="ohcCert === true && $i18n.locale !== 'zh'"
              src="~@/assets/images/event/oneHourCode/cert-dl-btn-E.png"
              @click="oneHourCertDownload()"
            />
          </div>
        </div>
        
        <div v-if="switchFlag == 0" class="bgBox" style="width:100%; height:auto;">
          <h1 :class="scale == 'L' ? 'myPageh1_L' : scale == 'M' ? 'myPageh1_M' : 'myPageh1_S'">{{ $t("helloWord") }}{{names}}{{ $t("greetWord") }}</h1>
          <div class="journeyFlex_L" :class="scale == 'L' ? 'journeyFlex_L' : scale == 'M' ? 'journeyFlex_M' : 'journeyFlex_S'">
            <div class="journeyItem" @mouseover="mouseHoverIndex = 1" @mouseout="mouseHoverIndex = 0" style="background-image:url('static/images/myPage_days.png');">
              
 
              <p class="journeyTitle">{{ $t("Joined ICode") }}</p>
              <el-tooltip
                class="item"
                effect="light"
                :content="showSignupDate()"
                placement="top"
              >
                <p class="journeyNum">
                  {{getDays(learningData.createTime)}}
                </p>
              </el-tooltip>
              
              <p class="journeyFooter">{{ $t("days ago") }}</p>
              
              <!-- <p v-if="mouseHoverIndex == 1">阿巴阿巴阿巴阿巴阿巴</p> -->
              <!-- <img src="~@/assets/images/myJourney_1.png"> -->
            </div>
            <div class="journeyItem" @mouseover="mouseHoverIndex = 2" @mouseout="mouseHoverIndex = 0" style="background-image:url('static/images/myPage_levels.png');">
              <p class="journeyTitle">{{ $t("Completed") }}</p>
              <el-tooltip
                  class="item"
                  effect="light"
                  :content="showStarData()"
                  placement="top"
                >
                <p class="journeyNum">
                  {{learningData.oneStarCount + learningData.twoStarCount + learningData.threeStarCount}}
                </p>
              </el-tooltip>
                
              <p class="journeyFooter">{{ $t("levels")}}</p>
              <!-- <img src="~@/assets/images/myJourney_1.png"> -->
            </div>
            <div class="journeyItem" @mouseover="mouseHoverIndex = 3" @mouseout="mouseHoverIndex = 0" style="background-image:url('static/images/myPage_competitions.png');">
              <p class="journeyTitle">{{ $t("Took part in")}}</p>
              <el-tooltip
                  class="item"
                  effect="light"
                  :content="showGameData()"
                  placement="top"
                >
                <p class="journeyNum">{{learningData.monthGameCount + learningData.otherGameCount}}</p>
              </el-tooltip>
              
              <p class="journeyFooter">{{$t("competitions")}}</p>
              <!-- <img src="~@/assets/images/myJourney_1.png"> -->
            </div>
            <div class="journeyItem" @mouseover="mouseHoverIndex = 4" @mouseout="mouseHoverIndex = 0" style="background-image:url('static/images/myPage_awards.png');">
              <p class="journeyTitle">{{$t("Won")}}</p>
              <el-tooltip
                  class="item"
                  effect="light"
                  :content="showAwardData()"
                  placement="top"
                >
                <p class="journeyNum">{{learningData.totalAwardCount}}</p>
              </el-tooltip>
              
              <p class="journeyFooter">{{$t("awards")}}</p>
              <!-- <img src="~@/assets/images/myJourney_1.png"> -->
            </div>
          </div>
          <div class="lfooter"></div>
          <div class="rfooter"></div>
        </div>

      </div>


      <div class="table" v-if="switchFlag != 0">
        
        <el-table :data="list" style="width: 100%">
          
          <!-- 无数据状态 -->
          <template slot="empty">
            <span style="color: #969696">{{$t("NO DATA")}}</span>
          </template>
          <!-- 比赛名称 -->
          <el-table-column
            prop="gameId"
            align="center"
            :label="$t('competitionName')"
            :formatter="courseFilter"
            :show-overflow-tooltip="true"
            min-width="250"
          ></el-table-column>

          <!-- 我的成绩 -->
          <el-table-column
            prop="awards"
            align="center"
            :label="$t('myAwards')"
            width="220"
            v-if="switchFlag == 1"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.awardEnd == 1">
                <div v-if="scope.row.awards && scope.row.awards.length != 0">
                  <div v-for="(item, index) in scope.row.awards" :key="index">

                    <img
                      v-if="item.prize == 1"
                      src="~@/assets/images/prize1.png"
                      width="20"
                      height="30"
                      alt
                    />
                    <img
                      v-if="item.prize == 2"
                      src="~@/assets/images/prize2.png"
                      width="20"
                      height="30"
                      alt
                    />
                    <img
                      v-if="item.prize == 3"
                      src="~@/assets/images/prize3.png"
                      width="20"
                      height="30"
                      alt
                    />
                    <!-- <span>{{ prizeFilter(item.prize) }}</span> -->
                    <span>{{ item.prizeName }}</span>
                    <el-button
                      type="text"
                      icon="el-icon-document"
                      @click="
                        downLoad(item, scope.row.gameId, 2, scope.row.gameType)
                      "
                    ></el-button>
                    <el-button
                      type="text"
                      icon="el-icon-download"
                      @click="
                        downLoad(item, scope.row.gameId, 1, scope.row.gameType)
                      "
                    ></el-button>
                  </div>
                </div>
                <span v-else>—</span>
              </div>
              <span v-else>{{ $t("race_unannounced") }}</span>
            </template>
          </el-table-column>

          <!-- 月赛成绩 -->
          <el-table-column
            prop="awards"
            align="center"
            :label="$t('myAwards')"
            width="220"
            v-if="switchFlag == 2"
          >
            <template slot-scope="scope">
              
              <div v-if="scope.row.awardEnd == 1">
                <div v-if="scope.row.awards && scope.row.awards.length != 0">
                  <div v-for="(item, index) in scope.row.awards" :key="index">
                    <img
                      v-if="
                        item.prize != 1 && item.prize != 2 && item.prize != 3
                      "
                      src="~@/assets/images/prizes.png"
                      width="20"
                      height="30"
                      alt
                    />
                    <img
                      v-if="item.prize == 1"
                      src="~@/assets/images/prize1.png"
                      width="20"
                      height="30"
                      alt
                    />
                    <img
                      v-if="item.prize == 2"
                      src="~@/assets/images/prize2.png"
                      width="20"
                      height="30"
                      alt
                    />
                    <img
                      v-if="item.prize == 3"
                      src="~@/assets/images/prize3.png"
                      width="20"
                      height="30"
                      alt
                    />
                    <span>{{ prizeFilter(item.prize) }}</span>

                    <el-button
                      style="margin-left: 10px"
                      type="text"
                      icon="el-icon-document"
                      @click="
                        downLoad(item, scope.row.gameId, 2, scope.row.gameType)
                      "
                    ></el-button>

                    <el-button
                      type="text"
                      icon="el-icon-download"
                      @click="
                        downLoad(item, scope.row.gameId, 1, scope.row.gameType)
                      "
                    ></el-button>
                  </div>
                </div>
                <div v-else>{{ $t("race_noaward") }}</div>
              </div>
              <span v-else>{{ $t("race_unannounced") }}</span>
            </template>
          </el-table-column>

          <!-- 比赛进度 -->
          <el-table-column
            prop="gameStatus"
            align="center"
            :label="$t('competitionProgress')"
            width="160"
            :formatter="gameFilter"
          ></el-table-column>
        </el-table>
        <div class="lfooter"></div>
        <div class="rfooter"></div>
      </div>
    </div>

    <LeapPopup
      v-show="maskBox"
      @onOK="logOut"
      :title="$t('timeout01')"
      :content="$t('timeout02')"
      :cancelButtonTxt="$t('timeout04')"
      :okButtonTxt="$t('timeout03')"
      :isConfirm="false"
    ></LeapPopup>

    <div class="bgiOver" v-show="imgShow" @click="imgShow = false" id="mainBox">
      <img alt :style="styleObj" id="img" />
    </div>

    <div
      id="qrcode"
      style="background: #fff;width: 300px; height: 300px;display:none"
    />
  </div>
</template>

<script>
import Axios from "axios";
import store from "../store";
import { mapGetters } from "vuex";
import { Loading } from "element-ui";
import MediaUtils from "@/utils/MediaUtils";
import LeapPopup from "./LeapPopup";
import QRCode from "qrcodejs2";

import {getGroupEnName, getGroupName, getTemplate, getTemplateConfig} from "@/utils/certificationCfg";
import {gameKeyFilter} from "@/utils/gameInfo";
import I18nUtils from "@/utils/i18nUtils";

Axios.defaults.withCredentials = true;

export default {
  name: "signIn",

  data() {
    return {
      changeLangBox: false,
      myOrotherShow: false,
      settingBoxVis: false,
      mouseHoverIndex: 0,
      names: "",
      imgShow: false,
      image: "",
      langList: I18nUtils.langList,
      list: [],
      imgTitle: "",
      switchFlag: 1, // 默认为活动赛记录
      apps: "",
      styleObj: { width: "596px", height: "843px" },
      scale: "L",

      ohcCert: false,
      ohcName: "",
      ohcCertId: "",
      ohcTime: "",
      learningData: [],
    };
  },

  components: {
    LeapPopup,
  },

  created() {
    // this.getLearningData();
    this.getMsg();
    this.setScale();
  },

  mounted() {
    this.names = localStorage.getItem("names") || "";

    I18nUtils.initLanguage(this);

    this.emailShowtext = this.$t("signup_txt13");

    // 编程一小时证书
    this.oneHourCertHandle();
  },

  methods: {
    setLanguage(lang) {
      I18nUtils.updateDivLanguage(lang);
      I18nUtils.setLanguage(this, lang);
    },
    
    // 获取比赛列表信息
    async getMsg(tab) {
      this.list = [];
      try {
        let res = await this.$http.getAxios("/user/myGame", {
          method: "post",
          data: {
            tab: tab || 0,
          },
        });
        if (res.data.code == "0") {
          this.list = res.data.data.reverse();
        }
      } catch (err) {
        console.log(err);
      }
    },

    // 获取账号大数据
    async getLearningData() {
      this.learningData = [];
      try {
        let res = await this.$http.getAxios("/user/getUserGameInfo", {
          method: "get",
          data: {
            // tab: tab || 0,
          },
        });
        if (res.data.code == "0") {
          this.learningData = res.data.data;
        }
      } catch (err) {
        console.log(err);
      }
    },

    setScale() {

      var w=window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      var h=window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

      if (w >= 1920) {
        this.scale = "L";
      }
      else if (w >= 1080) {
        this.scale = "M";
      }
      else {
        this.scale = "S";
      }

    },

    //展示注册日期
    showSignupDate() {
      let s = new Date(parseInt(this.learningData.createTime*1000));
      let y = s.getFullYear();
      let m = s.getMonth();
      let d = s.getDate();
      // let m_en = {1:"Jan.", 2:"Feb.", 3:"Mar.", 4:"Apr.", 5:"May", 6:"Jun.", 7:"Jul.", 8:"Aug.", 9:"Sep.", 10:"Oct.", 11:"Nov.", 12:"Dec."};
      // let th = (d == 1) ? "st" : (d == 2) ? "ed" : (d == 3) ? "rd" : "th";
      // if () {
      //   return ("你在" + y + "年" + m + "月" + d + "日注册了ICode学习平台，和你相遇是我们的荣幸" );
      // }
      // else {
      //   return ("You registered for ICode on " + m_en[m] + " " + d + th +", " + y + ".");
      // }
      return this.$t("You registered for ICode on {year}-{month}-{day}!", {year: y, month: m, day: d});

    },

    //展示星星情况
    showStarData() {
      return this.$t("There are {threeStarCount} levels got 3-Star, {twoStarCount} levels got 2-Star, {oneStarCount} levels got 1-Star. Good job!", 
        this.learningData);
    },

    //展示比赛情况
    showGameData() {
      return this.$t("You participated in {monthGameCount} level competitions and {otherGameCount} event competitions (including national and regional competitions).",
        this.learningData);
    },

    //展示获奖情况
    showAwardData() {
      return this.$t("In the competition, you have won {goldCount} gold awards, {silverCount} silver awards and {copperCount} bronze awards.", 
        this.learningData);
    },


    // 2020 广东&无锡地区赛决赛
    is2020_GD_WX_AREA(gameId) {
      if (
        gameId === 44111 ||
        gameId === 44112 ||
        gameId === 44113 ||
        gameId === 32111 ||
        gameId === 32112 ||
        gameId === 32113
      ) {
        return true;
      }
      return false;
    },
    // 2021全国预选赛
    is2021PreRace(gameId) {
      // 四个组别：积木初级、高级 | python初级、高级
      if (
        gameId == 202101 ||
        gameId == 202102 ||
        gameId == 202103 ||
        gameId == 202104
      ) {
        return true;
      }
      return false;
    },
    // 2021全国决赛
    is2021FinalRace(gameId) {
      // 四个组别：积木初级、高级 | python初级、高级
      if (
        gameId == 2021301 ||
        gameId == 2021302 ||
        gameId == 2021303 ||
        gameId == 2021304 ||
        gameId == 2021401 ||
        gameId == 2021402 ||
        gameId == 2021411 ||
        gameId == 2021412
      ) {
        return true;
      }
      return false;
    },
  
    async downLoad(item, gameId, type, gameType) {
      try {
        // loading 设置
        let loadingInstance = Loading.service({
          fullscreen: true,
          background: "rgba(0, 0, 0, 0.7)",
          text: "Loading",
          spinner: "el-icon-loading",
        });

        let res = await this.$http.getAxios("/user/myAward", {
          method: "post",
          data: {
            prize: item.prize,
            gameId: gameId,
          },
        });

        if (res.data.code == "0") {
          this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          }, 2000);

          let msgs = res.data.data;
          let cert = res.data.data;

          this.imgTitle = `${cert.gameName}_${cert.name}.png`;

          if(cert.certId) {
            this.drawCertification(cert, type);
            return;
          };

          let imgMsg = {
            // “执照”中的 【持有人】 一栏
            firstColor: "#39fff0",
            firstText: msgs.userLastNmae || ""  + msgs.userFirstName || "",

            // “执照”下方的 空白栏 一栏，填写firstText同样数据
            secondColor: "#15307d",
            secondText: (msgs.userLastNmae || "") + (msgs.userFirstName || ""),

            // 证书编号
            thirdText: msgs.certificateNo || "我是编号",

            // 奖项名称
            prizeName: msgs.prizeName || "奖项名",
            name: (msgs.userLastNmae || "") + (msgs.userFirstName || ""),
            certificateNo: msgs.certificateNo,

            // 学校名字
            schoolName: msgs.schoolName,

            // 级别
            // [myGame]API在组别中是用"edition"字段来判定，
            // [myAward]API在查看证书内容和下载证书中使用"awardEdition"字段来判定。
            // levelText: this.levelFilter(msgs.edition)  // 这个是错误的 [X]
            groupName: this.levelFilter(msgs.awardEdition, msgs.gameId),

            groupEnName: getGroupEnName(msgs.gameId),

            levelText:
              this.levelFilter(msgs.awardEdition, msgs.gameId) || "我是证书", // 这个是正确的 [✔]

            gameName: msgs.gameName || "",

            signDate: msgs.signDate || "颁发日期",
          };

          var pattern = new RegExp("^[a-zA-Z]+$");

          // 如果是外国名
          if (
            pattern.test(msgs.userLastNmae) &&
            pattern.test(msgs.userFirstName)
          ) {
            imgMsg.secondText = msgs.userFirstName + " " + msgs.userLastNmae;
          }

          if (gameType == 3) {
            imgMsg.thirdText = msgs.certificateNo || "";
            imgMsg.levelText = msgs.gameName;
          }
          this.drawPhoto(imgMsg, msgs.gameId, type, gameType, msgs.prize);
        } else {
          alert("下载失败，请重新尝试" || msgs.msg);
        }
      } catch (err) {
        console.log(err);
      }
    },

    /**
     * @brief 显示证书
     * @param imgMsg
     * @param gameId 赛事ID
     * @param type 证书类型 (个人证书 = 1,学校或者机构证书 = 0)
     * @param gameType 赛事类型 0：开放平台1：初赛；2：决赛；3：月赛；4：以色列比赛;5:免费教材；6：付费教材；7：付费月赛
     * @param prize 奖励类型 "1": "金奖","2": "银奖","3": "铜奖",16,明日之星（目前仅对2020中国区决赛有用）
     *
     * @param hint1 “可根据gameType值确定证书背景图”【全国奖项-初赛】gameType值为1，【全国奖项-决赛】gameType值为2，【月赛-晋级证书】gameType值为9，【月赛-（其他证书）】gameType值为3
     * @param hint2 “可根据prize值确定证书中的字段定位” 【金奖】-prize：1 | 【银奖】-prize：2 | 【铜奖】-prize：3 | 【参与奖】-prize：4 | 【奇思妙想奖】-prize：5 |
     *               【小小演说家】-prize：6 |      【最具潜质奖】-prize：7 | 【小小黑客奖】-prize：8 |       【女生创意奖】-prize：9 |  【男生创意奖】-prize：10 |
     *               【编程小能手】-prize：11 | 【最美推广大使】-prize：12 |    【天马行空奖】-prize：13 | 【”小试牛刀”奖】-prize：14 | 【”崭露头角”奖】-prize：15 |
     *               【明日之星】-prize：16 | 【未获奖】-prize：17 |            【晋级证书】-prize：18
     */
    drawPhoto(imgMsg, gameId, type = 1, gameType, prize) {
      let canvas = document.createElement("canvas"); //创建canvas
      let context = canvas.getContext("2d"); //创建画布

      let ratio = this.ratio(context);

      let img = new Image(); //因为拿不到图片静态资源，所以创建图片标签
      img.setAttribute("crossOrigin", "anonymous"); //解决图片跨域问题,也要放到赋值前，否贼大部分浏览器会报错

      // 单独的证书在这里处理 -----------------------------------------------------------------------
      // 2021-12-01 年新增证书统一处理
      let template = getTemplate(gameType, gameId, prize);
      if (template){
        img.src = MediaUtils.getStaticDomain() + "assets/template/" + template;

        img.onload = () => {
          let width = img.width;
          let height = img.height;

          let zoom = 1;
          if(width > height){
            this.styleObj.width = '800px';
            zoom = height / width;
            this.styleObj.height = 800 * zoom + 'px';
          } else {
            this.styleObj.height = '800px';
            zoom = width / height;
            this.styleObj.width = 800 * zoom + 'px';
          }

          canvas.width = width;
          canvas.height = height;

          // context.scale(1/ratio, 1/ratio); // 不再需要ratio
          context.drawImage(img, 0, 0, width, height);

          this.fillTextOnTemplate(template, context, imgMsg);

          let base64 = canvas.toDataURL("image/png");

          // 查看证书图片 - 下载证书的左侧按钮
          if (type == 2) {
            let imgs = document.getElementById("img");
            imgs.src = base64;

            this.imgShow = true;
            let screenHeight = document.body.clientHeight;
            let zoomRatio = this.changeRatio();

            // 若屏幕太小
            if (zoomRatio == "125" && screenHeight < 800) {
              imgs.style.transform = "scale(0.7) ";
            }
            if (zoomRatio == "150" && screenHeight < 800) {
              imgs.style.transform = "scale(0.6) ";
            }
            // 若屏幕太大
            if (zoomRatio == "100" && screenHeight > 1000) {
              imgs.style.transform = "scale(1.1)";
            }
            return;
          }
          this.downloadFileHandle(base64, this.imgTitle);
        }
        return;
      }
      // 单独证书处理结束 -------------------------------------------------------------

      let canvasWidth = 2481,
        canvasHeight = 3508;

      this.styleObj.width = "596px";
      this.styleObj.height = "843px";

      // 横版证书在此添加
      if (
        this.is2020_GD_WX_AREA(gameId) ||
        this.is2021PreRace(gameId) ||
        this.is2021FinalRace(gameId)
      ) {
        canvasWidth = 3509;
        canvasHeight = 2481;
        this.styleObj.width = "843px";
        this.styleObj.height = "596px";
      }

      canvas.width = canvasWidth * ratio;
      canvas.height = canvasHeight * ratio;

      // 证书背景图，通过gameType判断
      do {
        // 2021全国第三届预选赛
        if (this.is2021PreRace(gameId)) {
          if (prize == 1) {
            img.src =
              MediaUtils.getStaticDomain() + "assets/template/download-1.png";
          }
          if (prize == 2) {
            img.src =
              MediaUtils.getStaticDomain() + "assets/template/download-2.png";
          }
          if (prize == 3) {
            img.src =
              MediaUtils.getStaticDomain() + "assets/template/download-3.png";
          }
          if (prize == 16) {
            img.src =
              MediaUtils.getStaticDomain() + "assets/template/download-4.png";
          }
        }

        // 2021全国第三届决赛
        if (this.is2021FinalRace(gameId)) {
          if (prize == 1) {
            img.src =
              MediaUtils.getStaticDomain() + "assets/template/2021071601.jpg";
          }
          if (prize == 2) {
            img.src =
              MediaUtils.getStaticDomain() + "assets/template/2021071602.jpg";
          }
          if (prize == 3) {
            img.src =
              MediaUtils.getStaticDomain() + "assets/template/2021071603.jpg";
          }
          if (prize == 16) {
            img.src =
              MediaUtils.getStaticDomain() + "assets/template/2021071604.jpg";
          }
        }


        // 2020广东决赛 - 初、中、高 组别
        if (gameId === 44111 || gameId === 44112 || gameId === 44113) {
          if (prize == 1) {
            img.src =
              MediaUtils.getStaticDomain() + "assets/template/GD2020123001.png";
          }
          if (prize == 2) {
            img.src =
              MediaUtils.getStaticDomain() + "assets/template/GD2020123002.png";
          }
          if (prize == 3) {
            img.src =
              MediaUtils.getStaticDomain() + "assets/template/GD2020123003.png";
          }
          if (prize == 16) {
            img.src =
              MediaUtils.getStaticDomain() + "assets/template/GD2020123004.png";
          }
        }

        // 2020无锡梁溪区决赛 - 初、中、高 组别
        if (gameId === 32111 || gameId === 32112 || gameId === 32113) {
          if (prize == 1) {
            img.src =
              MediaUtils.getStaticDomain() + "assets/template/WX2020123001.png";
          }
          if (prize == 2) {
            img.src =
              MediaUtils.getStaticDomain() + "assets/template/WX2020123002.png";
          }
          if (prize == 3) {
            img.src =
              MediaUtils.getStaticDomain() + "assets/template/WX2020123003.png";
          }
          if (prize == 16) {
            img.src =
              MediaUtils.getStaticDomain() + "assets/template/WX2020123004.png";
          }
        }


        // 全国赛 | gameType为[1 or 2] | 1是初赛 | 2是决赛 ||
        if (
          (gameType == "1" || gameType == "2") &&
          (gameId == "1" || gameId == "5")
        ) {
          img.src =
            MediaUtils.getStaticDomain() + "assets/template/v1000001.png";
        }
        if (
          (gameType == "1" || gameType == "2") &&
          (gameId == "4" || gameId == "7")
        ) {
          img.src =
            MediaUtils.getStaticDomain() + "assets/template/v1000002.png";
        }

        /** ---------------- 分割线 ---------------- */

        // 月赛
        if (gameType == "3") {
          img.src =
            MediaUtils.getStaticDomain() + "assets/template/v1000006.png";
        }
        if (gameType == "9") {
          img.src =
            MediaUtils.getStaticDomain() + "assets/template/v1000007.png";
        }
      } while (false);

      //加载图片
      img.onload = () => {
        // 绘制图片
        context.drawImage(img, 0, 0, canvasWidth * ratio, canvasHeight * ratio);

        // 证书的数据定位，通过prize判断
        do {
          // 月赛证书 - 包含【晋级 - 9】和【其他 - 3】
          if (gameType == 3 || gameType == 9) {
            //  晋级证书
            if (prize == 18) {
              {
                /**
                 * @param  火星航行执照
                 */

                // 字体样式
                context.font = "700 " + 60 * ratio + "px" + " 微软雅黑";
                context.fillStyle = imgMsg.firstColor;

                // 显示 “火星航行执照” 的 【持有人】 一栏
                context.fillText(imgMsg.firstText, 1350 * ratio, 1605 * ratio);
                // 显示 “火星航行执照” 的 【颁发日期】 一栏
                context.fillText(imgMsg.signDate, 1350 * ratio, 1785 * ratio);
              }
              {
                /**
                 * @param 虚线上方的名字
                 */

                // 字体样式
                context.font = "700 " + 100 * ratio + "px" + " 微软雅黑";
                context.fillStyle = imgMsg.secondColor;
                context.textAlign = "center";
                context.fillText(
                  imgMsg.secondText,
                  (canvasWidth / 2) * ratio,
                  2284 * ratio
                );
              }
              {
                /**
                 * @param  信息栏
                 */

                // 字体样式
                context.font = "700 " + 80 * ratio + "px" + " 微软雅黑";
                context.fillStyle = imgMsg.secondColor;
                context.textAlign = "start";
                // 证书编号
                context.fillText(imgMsg.thirdText, 1140 * ratio, 2506 * ratio);
                // 比赛名
                context.fillText(imgMsg.gameName, 1140 * ratio, 2627 * ratio);
                // 等级
                // context.fillText(imgMsg.levelText, 1140 * ratio, 2627 * ratio);
                // 参赛者名字
                // context.fillText(imgMsg.firstText, 1140 * ratio, 2766 * ratio);
              }
            }

            // 除了晋级证书，其他月赛的奖都是同样的模板
            if (prize != 18) {
              {
                /**
                 * @param  获奖代码框
                 */

                // 顶部定位  #0ff 小字
                context.font = "700 " + 60 * ratio + "px" + " 微软雅黑";
                context.fillStyle = imgMsg.firstColor;

                context.fillText(imgMsg.prizeName, 1380 * ratio, 1615 * ratio);
              }
              {
                /**
                 * @param 虚线上方的名字
                 *
                 */

                // 字体样式
                context.font = "700 " + 100 * ratio + "px" + " 微软雅黑";
                context.fillStyle = imgMsg.secondColor;
                context.textAlign = "center";
                context.fillText(
                  imgMsg.secondText,
                  // (ws - 180) * ratio,
                  (canvasWidth / 2) * ratio,
                  2284 * ratio
                );
              }
              {
                /**
                 * @param 信息栏
                 */
                // 字体样式
                context.font = "700 " + 80 * ratio + "px" + " 微软雅黑";
                context.fillStyle = imgMsg.secondColor;
                context.textAlign = "start";
                // 证书
                context.fillText(imgMsg.thirdText, 940 * ratio, 2506 * ratio);
                // 比赛名
                context.fillText(imgMsg.gameName, 940 * ratio, 2627 * ratio);
                // 奖项
                context.fillText(imgMsg.prizeName, 940 * ratio, 2766 * ratio);
              }
            }
          }

          // 全国赛 初赛
          if (gameType == 1) {
            // 字体文字，显示位置
            let ws =
              (canvas.width - context.measureText(imgMsg.secondText).width) /
              (2 * ratio);

            // 2021年第三届全国预选赛
            if (this.is2021PreRace(gameId)) {
              context.font = "700 " + 100 * ratio + "px" + " 微软雅黑";
              context.fillStyle = "#333";
              context.textAlign = "center";

              if (prize == 16) {
                // 明日之星
                context.fillText(imgMsg.secondText, 2420 * ratio, 910 * ratio);
              }

              if (prize == 3) {
                // 铜
                context.fillText(imgMsg.secondText, 1760 * ratio, 1090 * ratio);
              }

              if (prize == 2) {
                // 银
                context.fillText(imgMsg.secondText, 1760 * ratio, 1160 * ratio);
              }

              if (prize == 1) {
                // 金
                context.fillText(imgMsg.secondText, 1605 * ratio, 1330 * ratio);
              }

              //  证书编码 thirdText | 组别 levelText |  签发日期 signDate
              context.font = "700 " + 60 * ratio + "px" + " 微软雅黑";

              if (prize == 16) {
                context.fillText(imgMsg.thirdText, 2730 * ratio, 1600 * ratio);
                context.fillText(imgMsg.levelText, 2730 * ratio, 1700 * ratio);
                context.fillText(imgMsg.signDate, 2730 * ratio, 1995 * ratio);
              }
              if (prize == 3) {
                context.fillText(imgMsg.thirdText, 2060 * ratio, 1688 * ratio);
                context.fillText(imgMsg.levelText, 2060 * ratio, 1782 * ratio);
                context.fillText(imgMsg.signDate, 2060 * ratio, 2080 * ratio);
              }
              if (prize == 2) {
                context.fillText(imgMsg.thirdText, 2060 * ratio, 1750 * ratio);
                context.fillText(imgMsg.levelText, 2060 * ratio, 1838 * ratio);
                context.fillText(imgMsg.signDate, 2060 * ratio, 2137 * ratio);
              }
              if (prize == 1) {
                context.fillText(imgMsg.thirdText, 1890 * ratio, 1917 * ratio);
                context.fillText(imgMsg.levelText, 1890 * ratio, 2015 * ratio);
                context.fillText(imgMsg.signDate, 1890 * ratio, 2310 * ratio);
              }
              break;
            }

            // 第一届和第二届的初赛证书中的数据定位相同
            {
              /**
               * @param  获奖代码框
               */

              // 顶部定位  #0ff 小字
              context.font = "700 " + 60 * ratio + "px" + " 微软雅黑";
              context.fillStyle = imgMsg.firstColor;

              context.fillText(imgMsg.prizeName, 1380 * ratio, 1615 * ratio);
            }
            {
              /**
               * @param 虚线上方的名字
               *
               */

              // 字体样式
              context.font = "700 " + 100 * ratio + "px" + " 微软雅黑";
              context.fillStyle = imgMsg.secondColor;

              context.fillText(
                imgMsg.secondText,
                (ws - 180) * ratio,
                2284 * ratio
              );
            }
            {
              /**
               * @param 信息栏
               */
              // 字体样式
              context.font = "700 " + 80 * ratio + "px" + " 微软雅黑";
              context.fillStyle = imgMsg.secondColor;

              // 证书
              context.fillText(imgMsg.thirdText, 1140 * ratio, 2506 * ratio);
              // 比赛名
              context.fillText(imgMsg.levelText, 1140 * ratio, 2627 * ratio);
              // 奖项
              context.fillText(imgMsg.prizeName, 1140 * ratio, 2766 * ratio);
            }
          }

          // 全国赛 决赛
          if (gameType == 2) {
            // 字体文字，显示位置
            let ws =
              (canvas.width - context.measureText(imgMsg.secondText).width) /
              (2 * ratio);

            // 2021年第三届全国决赛
            if (this.is2021FinalRace(gameId)) {
              context.font = "700 " + 100 * ratio + "px" + " 微软雅黑";
              context.fillStyle = "#333";
              context.textAlign = "center";

              if (prize == 16) {
                // 明日之星
                context.fillText(imgMsg.secondText, 2420 * ratio, 910 * ratio);
              }

              if (prize == 3) {
                // 铜
                context.fillText(imgMsg.secondText, 1760 * ratio, 1090 * ratio);
              }

              if (prize == 2) {
                // 银
                context.fillText(imgMsg.secondText, 1760 * ratio, 1160 * ratio);
              }

              if (prize == 1) {
                // 金
                context.fillText(imgMsg.secondText, 1605 * ratio, 1330 * ratio);
              }

              //  证书编码 thirdText | 组别 levelText |  签发日期 signDate
              context.font = "700 " + 60 * ratio + "px" + " 微软雅黑";

              if (prize == 16) {
                context.fillText(imgMsg.thirdText, 2730 * ratio, 1600 * ratio);
                context.fillText(imgMsg.levelText, 2730 * ratio, 1700 * ratio);
                context.fillText(imgMsg.signDate, 2730 * ratio, 1995 * ratio);
              }
              if (prize == 3) {
                context.fillText(imgMsg.thirdText, 2060 * ratio, 1688 * ratio);
                context.fillText(imgMsg.levelText, 2060 * ratio, 1782 * ratio);
                context.fillText(imgMsg.signDate, 2060 * ratio, 2080 * ratio);
              }
              if (prize == 2) {
                context.fillText(imgMsg.thirdText, 2060 * ratio, 1750 * ratio);
                context.fillText(imgMsg.levelText, 2060 * ratio, 1838 * ratio);
                context.fillText(imgMsg.signDate, 2060 * ratio, 2137 * ratio);
              }
              if (prize == 1) {
                context.fillText(imgMsg.thirdText, 1890 * ratio, 1917 * ratio);
                context.fillText(imgMsg.levelText, 1890 * ratio, 2015 * ratio);
                context.fillText(imgMsg.signDate, 1890 * ratio, 2310 * ratio);
              }
              break;
            }

            // 2020广东地区赛决赛  和 2020无锡梁溪区地区赛决赛 定位相同
            if (this.is2020_GD_WX_AREA(gameId)) {
              // 字体居中对齐
              context.textAlign = "center";

              switch (prize) {
                case 1: {
                  {
                    //  用户姓名
                    context.font = "700 " + 100 * ratio + "px" + " 微软雅黑";
                    context.fillStyle = imgMsg.secondColor;
                    context.fillText(
                      imgMsg.firstText,
                      1600 * ratio,
                      1340 * ratio
                    );
                  }
                  {
                    //  证书编号
                    context.font = "500 " + 60 * ratio + "px" + " 微软雅黑";
                    context.fillStyle = "#000";
                    context.fillText(
                      imgMsg.thirdText,
                      1940 * ratio,
                      1920 * ratio
                    );
                  }
                  {
                    //  组别
                    context.font = "500 " + 60 * ratio + "px" + " 微软雅黑";
                    context.fillStyle = "#000";
                    context.fillText(
                      imgMsg.levelText,
                      1940 * ratio,
                      2010 * ratio
                    );
                  }
                  {
                    //  签发日期
                    context.font = "500 " + 60 * ratio + "px" + " 微软雅黑";
                    context.fillStyle = "#000";
                    context.fillText(
                      imgMsg.signDate,
                      1940 * ratio,
                      2310 * ratio
                    );
                  }
                  break;
                }

                case 2: {
                  {
                    //  用户姓名
                    context.font = "700 " + 100 * ratio + "px" + " 微软雅黑";
                    context.fillStyle = imgMsg.secondColor;
                    context.fillText(
                      imgMsg.firstText,
                      1755 * ratio,
                      1155 * ratio
                    );
                  }
                  {
                    //  证书编号
                    context.font = "500 " + 60 * ratio + "px" + " 微软雅黑";
                    context.fillStyle = "#000";
                    context.fillText(
                      imgMsg.thirdText,
                      2060 * ratio,
                      1760 * ratio
                    );
                  }
                  {
                    //  组别
                    context.font = "500 " + 60 * ratio + "px" + " 微软雅黑";
                    context.fillStyle = "#000";
                    context.fillText(
                      imgMsg.levelText,
                      2060 * ratio,
                      1855 * ratio
                    );
                  }
                  {
                    //  签发日期
                    context.font = "500 " + 60 * ratio + "px" + " 微软雅黑";
                    context.fillStyle = "#000";
                    context.fillText(
                      imgMsg.signDate,
                      2060 * ratio,
                      2155 * ratio
                    );
                  }
                  break;
                }

                case 3: {
                  {
                    //  用户姓名
                    context.font = "700 " + 100 * ratio + "px" + " 微软雅黑";
                    context.fillStyle = imgMsg.secondColor;
                    context.fillText(
                      imgMsg.firstText,
                      1755 * ratio,
                      1100 * ratio
                    );
                  }
                  {
                    //  证书编号
                    context.font = "500 " + 60 * ratio + "px" + " 微软雅黑";
                    context.fillStyle = "#000";
                    context.fillText(
                      imgMsg.thirdText,
                      2055 * ratio,
                      1760 * ratio
                    );
                  }
                  {
                    //  组别
                    context.font = "500 " + 60 * ratio + "px" + " 微软雅黑";
                    context.fillStyle = "#000";
                    context.fillText(
                      imgMsg.levelText,
                      2055 * ratio,
                      1855 * ratio
                    );
                  }
                  {
                    //  签发日期
                    context.font = "500 " + 60 * ratio + "px" + " 微软雅黑";
                    context.fillStyle = "#000";
                    context.fillText(
                      imgMsg.signDate,
                      2055 * ratio,
                      2155 * ratio
                    );
                  }
                  break;
                }

                case 16: {
                  {
                    //  用户姓名
                    context.font = "700 " + 100 * ratio + "px" + " 微软雅黑";
                    context.fillStyle = imgMsg.secondColor;
                    context.fillText(
                      imgMsg.firstText,
                      2430 * ratio,
                      920 * ratio
                    );
                  }
                  {
                    //  证书编号
                    context.font = "500 " + 60 * ratio + "px" + " 微软雅黑";
                    context.fillStyle = "#000";
                    context.fillText(
                      imgMsg.thirdText,
                      2730 * ratio,
                      1650 * ratio
                    );
                  }
                  {
                    //  组别
                    context.font = "500 " + 60 * ratio + "px" + " 微软雅黑";
                    context.fillStyle = "#000";
                    context.fillText(
                      imgMsg.levelText,
                      2730 * ratio,
                      1750 * ratio
                    );
                  }
                  {
                    //  签发日期
                    context.font = "500 " + 60 * ratio + "px" + " 微软雅黑";
                    context.fillStyle = "#000";
                    context.fillText(
                      imgMsg.signDate,
                      2730 * ratio,
                      2050 * ratio
                    );
                  }
                  break;
                }
              }
              break;
            }
          }
        } while (false);

        context.save();
        context.restore();
        //合成图片
        let base64 = canvas.toDataURL("image/png");

        // 查看证书图片 - 下载证书的左侧按钮
        if (type == 2) {
          let imgs = document.getElementById("img");
          imgs.src = base64;
          this.imgShow = true;
          let screenHeight = document.body.clientHeight;
          let zoomRatio = this.changeRatio();

          // 若屏幕太小
          if (zoomRatio == "125" && screenHeight < 800) {
            imgs.style.transform = "scale(0.7) ";
          }
          if (zoomRatio == "150" && screenHeight < 800) {
            imgs.style.transform = "scale(0.6) ";
          }
          // 若屏幕太大
          if (zoomRatio == "100" && screenHeight > 1000) {
            imgs.style.transform = "scale(1.1)";
          }

          return;
        }
        this.downloadFileHandle(base64, this.imgTitle);
      };
    },

    async drawCertification(certInfo, type) {
      this.$http.getAxios.get("/award/queryCertificationConfig", {
        params: {
          id: certInfo.certId,
        },
      }).then((res) => {
          const _res = res.data;

          let url, certConfigList;
          if (_res.code == 0 && _res.data[0] != null) {
            try {
              url = _res.data[0].url;
              certConfigList = JSON.parse(_res.data[0].config)
            } catch (e) {
              console.log("Can not parse cert config");
              return;
            }
          } else {
            console.log("Can not get cert config");
            return;
          }

        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        let img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.src = url;

        img.onload = () => {
          let width = img.width;
          let height = img.height;

          canvas.width = width;
          canvas.height = height;

          if(width > height){
            this.styleObj.width = '800px';
            this.styleObj.height = 800 * height/width + 'px';
          } else {
            this.styleObj.height = '800px';
            this.styleObj.width = 800 * width/height + 'px';
          }

          ctx.drawImage(img, 0, 0, width, height);

          certConfigList.forEach(tag => {
              ctx.font = tag.font;
              ctx.textAlign = tag.textAlign;
              ctx.fillStyle = tag.fillStyle;
              ctx.fillText(certInfo[tag.tagName], tag.x*width/100, tag.y*height/100);
          })

          let base64 = canvas.toDataURL("image/png");
          let imgs = document.getElementById("img");

          imgs.src = base64;
          this.imgSrc = base64;

          // 查看证书图片 - 下载证书的左侧按钮
          if (type == 2) {
            let imgs = document.getElementById("img");
            imgs.src = base64;

            this.imgShow = true;
            let screenHeight = document.body.clientHeight;
            let zoomRatio = this.changeRatio();

            // 若屏幕太小
            if (zoomRatio == "125" && screenHeight < 800) {
              imgs.style.transform = "scale(0.7) ";
            }
            if (zoomRatio == "150" && screenHeight < 800) {
              imgs.style.transform = "scale(0.6) ";
            }
            // 若屏幕太大
            if (zoomRatio == "100" && screenHeight > 1000) {
              imgs.style.transform = "scale(1.1)";
            }
            return;
          }

          this.downloadFileHandle(base64, this.imgTitle);
          return;
        };
      })
    },

    // 将文字绘制在图上
    fillTextOnTemplate(template, ctx, imgMsg){
      let textsCfg = getTemplateConfig(template);
      let texts = Object.keys(textsCfg);  // ['name', 'certificateNo', ... ]

      for(let i=0; i<texts.length; i++){
        let text = texts[i];       // 'name' or 'certificateNo' or ... 
        let cfg = textsCfg[text];  // {font: "微软雅黑", fontSize: 100, fillStyle: "#333", textAlign: "center", x: 1605, y:1330},
        
        ctx.font = cfg.font;
        ctx.textAlign = cfg.textAlign;
        ctx.fillStyle = cfg.fillStyle;

        ctx.fillText(imgMsg[text], cfg.x, cfg.y);
      }
    },

    // 一小时下载证书
    oneHourCertHandle() {
      try {
        this.$http.getAxios.get("/award/getAward").then((res) => {
          const _res = res.data;

          if (_res.code == 0 && _res.data != null) {
            this.ohcName = _res.data.firstName;
            this.ohcTime = _res.data.createTime;
            this.ohcCertId = _res.data.number;
            this.ohcCert = true;
          } else {
            this.ohcCert = false;
          }
        });
      } catch (error) {
        console.debug("err0r-getAward", error);
      }
    },
    oneHourCertDownload() {
      let canvas = document.createElement("canvas");
      let context = canvas.getContext("2d");
      let ratio = this.ratio(context);

      let canvasWidth = 3508,
        canvasHeight = 2481;

      canvas.width = canvasWidth * ratio;
      canvas.height = canvasHeight * ratio;

      //因为拿不到图片静态资源，所以创建图片标签
      let img = new Image();
      //解决图片跨域问题,也要放到赋值前，否贼大部分浏览器会报错
      img.setAttribute("crossOrigin", "anonymous");
      // 证书背景
      img.src =
        MediaUtils.getStaticDomain() + "assets/template/v2020121101.png";

      try {
        img.onload = () => {
          context.drawImage(
            img,
            0,
            0,
            canvasWidth * ratio,
            canvasHeight * ratio
          );

          // 内容居中
          context.textAlign = "center";
          {
            // 姓名
            context.font = "700 " + 120 * ratio + "px" + " 微软雅黑";
            // 颜色
            context.fillStyle = "#016863";
            // 定位
            context.fillText(
              this.ohcName,
              (canvasWidth / 2) * ratio,
              1280 * ratio
            );
          }
          {
            // 编号
            context.font = "700 " + 60 * ratio + "px" + " 微软雅黑";
            // 颜色
            context.fillStyle = "#016863";
            // 定位
            context.fillText(
              this.ohcCertId,
              (canvasWidth / 2) * ratio,
              1775 * ratio
            );
          }
          {
            // 日期
            context.font = "700 " + 80 * ratio + "px" + " 微软雅黑";
            // 颜色
            context.fillStyle = "#000";
            // 定位
            context.fillText(
              this.ohcTime,
              (canvasWidth / 2) * ratio,
              2070 * ratio
            );
          }

          // 合成图片
          context.save();
          context.restore();
          let base64 = canvas.toDataURL("image/png");

          // 下载图片
          this.downloadFileHandle(
            base64,
            this.$t("{name} - One Hour Coding Certificate", {name: this.ohcName})
          );
 
        };
      } catch (error) {
        console.debug("error", error);
      }
    },

    // 参赛证打印
    async downLoadAdmissionTicket(val) {
      try {
        let obj = {};
        let res = await this.$http.getAxios("/user/getFinalUserInfo", {
          method: "get",
          params: {
            gameId: val,
          },
        });
        if (res.data.code == "0") {
          obj = {
            imgUrl: res.data.data.photoUrl,
            name: res.data.data.userFirstName,
            gameAliasName: res.data.data.gameAliasName,
            areaName: res.data.data.areaName,
            schoolName: res.data.data.schoolName,
            grade: this.gradeFilter(res.data.data.grade),
            // 小程序扫此数字生成的二维码
            ticket: res.data.data.ticket,
          };

          this.drawAndShareImageHandle(obj);
        } else if (res.data.code == "104") {
          this.$message({
            type: "warning",
            message: "不能下载参赛证-不在下载开放时间段",
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 参赛证下载支持
    drawAndShareImageHandle(obj) {
      new QRCode(document.getElementById("qrcode"), {
        text: obj.ticket, // 二维码内容
        correctLevel: QRCode.CorrectLevel.L, // 容错率，L/M/H，从低到高
      });

      let that = this;
      let canvas = document.createElement("canvas");
      canvas.width = 2481;
      canvas.height = 3581;
      let context = canvas.getContext("2d");
      context.rect(0, 0, canvas.width, canvas.height);
      context.fillStyle = "#15307d";
      context.textAlign = "center";
      context.fill();

      var myImage = new Image();
      myImage.setAttribute("crossOrigin", "anonymous"); //解决图片跨域问题,也要放到赋值前，否贼大部分浏览器会报错
      // 参赛证背景
      myImage.src =
        MediaUtils.getStaticDomain() + "assets/template/2021063001.jpg";
      // 背景定位，在背景上写入数据
      myImage.onload = function() {
        context.drawImage(myImage, 0, 0, 2481, 3581);

        context.font = " 80px 微软雅黑";
        context.fillText(obj.name, 1500, 1170);
        context.fillText(obj.gameAliasName, 1500, 1320);
        context.fillText(obj.areaName, 1500, 1460);
        context.fillText(obj.schoolName, 1500, 1600);
        context.fillText(obj.grade, 1500, 1750);

        // 添加小程序签到二维码
        let b = document.getElementById("qrcode").lastChild;
        b.setAttribute("crossOrigin", "annoymous");

        // 用户照片
        var myImage2 = new Image();
        myImage2.setAttribute("crossOrigin", "anonymous"); //解决图片跨域问题,也要放到赋值前，否贼大部分浏览器会报错
        myImage2.src = obj.imgUrl;

        myImage2.onload = function() {
          context.drawImage(b, 1260, 2950, 350, 350);
          context.drawImage(myImage2, 260, 1150, 413, 626);

          var base64 = canvas.toDataURL("image/png");
          that.$nextTick(() => {
            that.$forceUpdate();
            that.downloadFileHandle(base64, "参赛证");
          });
        };
      };
    },

    // 下载证书功能支持
    downloadFileHandle(path, name) {
      const xhr = new XMLHttpRequest();
      xhr.open("get", path);
      xhr.responseType = "blob";
      xhr.send();
      xhr.onload = function() {
        if (this.status === 200 || this.status === 304) {
          // 如果是IE10及以上，不支持download属性，采用msSaveOrOpenBlob方法，但是IE10以下也不支持msSaveOrOpenBlob
          if ("msSaveOrOpenBlob" in navigator) {
            navigator.msSaveOrOpenBlob(this.response, name);
            return;
          }
          // const blob = new Blob([this.response], { type: xhr.getResponseHeader('Content-Type') });
          // const url = URL.createObjectURL(blob);
          const url = URL.createObjectURL(this.response);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = name;
          document.body.appendChild(a); // 不插入到dom，在火狐浏览器直接触发a.click是不会触发下载的，需要插入到dom里
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }
      };
    },

    moreLang() {
      this.changeLangBox = !this.changeLangBox;
      this.settingBoxVis = false;
    },
    setting() {
      this.settingBoxVis = !this.settingBoxVis;
      this.changeLangBox = false;
    },

    toMyAccount() {
      this.$router.push({ path: "/myAccount" });
    },
    goIndex() {
      this.$router.push({ path: "/index" });
    },
    logOut() {
      this.$http
        .getAxios("/user/logout", {
          method: "post",
        })
        .then((res) => {
          var res = res.data;
          if (res.code == "0") {
            store.commit("toggleMaskState", false);
            localStorage.removeItem("competeObj");
            localStorage.removeItem("signIn");
            localStorage.removeItem("emailComp");
            this.$router.push({ path: "/" });
          }
        });
    },

    //根据当前时间计算已经加入的天数
    getDays(startTimestamp) {
      var endDay = Math.floor(Date.parse(new Date()) / 1000 / 86400);
      var startDay = Math.floor(startTimestamp / 86400);
      var days = endDay - startDay;
      return days;
    },

    // 月赛 switch 全国赛
    switchMode(val) {
      this.switchFlag = val;
      if (this.switchFlag == 1) this.getMsg(0);
      else if (this.switchFlag == 2) this.getMsg(1);
      else if (this.switchFlag == 0) {
        this.setScale();
        this.getLearningData();
      }
    },
    ratio(context) {
      var backingStore =
        context.backingStorePixelRatio ||
        context.webkitBackingStorePixelRatio ||
        context.mozBackingStorePixelRatio ||
        context.msBackingStorePixelRatio ||
        context.oBackingStorePixelRatio ||
        context.backingStorePixelRatio ||
        1;
      return (window.devicePixelRatio || 1) / backingStore;
    },
    // 处理图片模糊
    changeRatio() {
      var ratio = 0;
      var screen = window.screen;
      var ua = navigator.userAgent.toLowerCase();
      if (window.devicePixelRatio !== undefined)
        ratio = window.devicePixelRatio;
      else if (~ua.indexOf("msie")) {
        if (screen.deviceXDPI && screen.logicalXDPI)
          ratio = screen.deviceXDPI / screen.logicalXDPI;
      } else if (
        window.outerWidth !== undefined &&
        window.innerWidth !== undefined
      ) {
        ratio = window.outerWidth / window.innerWidth;
      }
      if (ratio) ratio = Math.round(ratio * 100);
      return ratio;
    },
    gameFilter(row) {
      const statusMap = {
        0: this.$t("notStart"),
        1: this.$t("ongoing"),
        2: this.$t("gameover"),
      };
      return statusMap[row.gameStatus];
    },

    finalRegFilter(row) {
      const statusMap = {
        0: this.$t("registrationReview"),
        1: this.$t("registrationFailed"),
        2: this.$t("registrationSpproved"),
        3: this.$t("notParticipated"),
        4: this.$t("participated"),
      };
      return statusMap[row];
    },

    levelFilter(edition, gameId) {
    // 2021年前的组别由edition来决定组别
      if(gameId == 4){
        const statusMap = {
          0: this.$t("begin"),
          1: this.$t("levelProgress1"),
          2: this.$t("levelProgress2"),
          3: this.$t("levelProgress3"),
        };
        return statusMap[edition];
      }

      return getGroupName(gameId);
    },


    gradeFilter(status) {
      const statusMap = {
        1: "一年级",
        2: "二年级",
        3: "三年级",
        4: "四年级",
        5: "五年级",
        6: "六年级",
        7: "七年级",
        8: "八年级",
        9: "九年级",
        10: "十年级",
        11: "十一年级",
        12: "十二年级",
      };
      return statusMap[status];
    },

    prizeFilter(status) {
      const statusMap = {
        1: this.$t("prizeId_1"),
        2: this.$t("prizeId_2"),
        3: this.$t("prizeId_3"),
        4: this.$t("prizeId_4"),
        5: this.$t("prizeId_5"),
        6: this.$t("prizeId_6"),
        7: this.$t("prizeId_7"),
        8: this.$t("prizeId_8"),
        9: this.$t("prizeId_9"),
        10: this.$t("prizeId_10"),
        11: this.$t("prizeId_11"),
        12: this.$t("prizeId_12"),
        13: this.$t("prizeId_13"),
        14: this.$t("prizeId_14"),
        15: this.$t("prizeId_15"),
        16: this.$t("prizeId_16"),
        18: this.$t("prizeId_18"),
        19: this.$t("Honor Roll of Distinction"),
        20: this.$t("Honor Roll"),
        21: this.$t("Achievement Roll"),
        22: this.$t("Certificate of Distinction"),
        23: this.$t("Certificate of Participation"),
      };
      return statusMap[status];
    },
    
    // 处理比赛名称的显示
    courseFilter(row) {
      let rs = gameKeyFilter(row.gameId);
      //存在keyValue，按月赛处理
      if (rs.keyValue) {
        return this.$t(rs.key,rs.keyValue);
      }
      //其他比赛先如果没有配置语言包，直接读数据库中的比赛名称
      if (this.$t(rs.key) == rs.key) {
        return row.gameName;
      }
      //如果配置了就读语言包
      return this.$t(rs.key);
    },
  },

  computed: {
    ...mapGetters(["maskBox", "name"]),
    lan() {
      return this.$i18n.locale;
    },
  },
};
</script>

<style lang="scss" scoped>
.topbar {
  width: 100%;
  height: 60px;
  color: #aaf9fe;
  background: #122346;
  i {
    position: absolute;
    top: 8px;
    left: 40px;
    width: 172px;
    height: 46px;
    cursor: pointer;
    z-index: 99999999999999999;
    background: url("~@/assets/images/bigIcon.png") no-repeat center;
  }
}
.fr {
  width: 473px !important;
}
.mainBox1 {
  height: 60px;
  position: absolute;
  top: 0;
  right: 20px;
  z-index: 2;
}
.topbar span {
  font-size: 20px;
  line-height: 60px;
  margin-left: 100px;
}
.mainBox {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
}
.journeyBox {
  // background-image:;
  padding-top:30px;
  width:80%;
  padding-left:10%;
  padding-right:10%;
  .tagButtonFlex {
    width:100%;
    flex-direction: row;
    display: -webkit-flex; 
    display: flex;
    flex-wrap: wrap;
    // margin-top: 30px;
    margin: auto 0;
    .tagButton {
      width: 150px;
      height:40px;
      background: url("~@/assets/images/useCodeBtn.png") no-repeat;
      background-size:100% 100%;
      border-style: none;
      margin-right:20px;
      // padding-right:40px;
      color:#39fff0;
      text-align: center;
      font-weight: bold;
      font-size:1em;
    }

      .activeTagButton {
      width: 150px;
      height:40px;
      background: url("~@/assets/images/useCodeBtn2.png") no-repeat;
      background-size:100% 100%;
      border-style: none;
      margin-right:20px;
      // padding-right:40px;
      color:#ffffff;
      text-align: center;
      font-weight: bold;
      font-size:1em;
      
    }
    
  }
  .bgBox {
      width:100%;
      height:auto;
      margin: 30px auto;
      padding-bottom: 30px;
      border-radius: 15px;
      position: relative;
      
      border: 5px #39fff0 solid;
      background-color: #002b46;
      // border-style: none;
      // margin-right:20px;
      .myPageh1_L {
        text-align:center;
        color:white;
        margin-top:50px;
        font-size:2.4em;
      }

      .myPageh1_M {
        text-align:center;
        color:white;
        margin-top:50px;
        font-size:1.8em;
      }
      .myPageh1_S {
        text-align:center;
        color:white;
        margin-top:50px;
        font-size:1.2em;
      }
      .lfooter {
        width: 85px;
        height: 86px;
        background: url("~@/assets/images/lfooter.png") no-repeat center;
        background-size: cover;
        position: absolute;
        left: -15px;
        bottom: -10px;
      }
      .rfooter {
        width: 85px;
        height: 86px;
        background: url("~@/assets/images/rfooter.png") no-repeat center;
        background-size: cover;
        position: absolute;
        right: -15px;
        bottom: -10px;
      }
    }
  
  .journeyFlex_L {
    margin:50px 5%;
    width:90%;
    flex-direction: row;
    justify-content: space-between;
    display: -webkit-flex; 
    display: flex;
    flex-wrap: wrap;

    .journeyItem {
      width:240px;
      height:310px;
      background-repeat: no-repeat;
      background-position: center;
      text-align: center;
      -moz-background-size: 100% 100%;  
      -o-background-size: 100% 100%;  
      -webkit-background-size: 100% 100%;  
      background-size: 100% 100%;
      // width: 20%;
      .journeyTitle {
        padding-top:55%;
        color: white;
        font-size: 1.4em;
        text-shadow: #000000 0px 0px 6px;
        // font-weight: bold;
      }
      .journeyNum {
        padding-top:6%;
        color: rgb(251, 255, 6);
        font-size: 2.2em;
        font-weight: bold;
        text-shadow: #000000 0px 0px 6px;
      }
      .journeyFooter {
        padding-top:8%;
        color: white;
        font-size: 1.4em;
        text-shadow: #000000 0px 0px 6px;
        // font-weight: bold;
      }
    }
  }

  .journeyFlex_M {
    margin:50px 5%;
    width:90%;
    flex-direction: row;
    justify-content: space-between;
    display: -webkit-flex; 
    display: flex;
    flex-wrap: wrap;

    .journeyItem {
      width:192px;
      height:248px;
      background-repeat: no-repeat;
      background-position: center;
      text-align: center;
      // background-clip: append;
      -moz-background-size: 100% 100%;  
      -o-background-size: 100% 100%;  
      -webkit-background-size: 100% 100%;  
      background-size: 100% 100%;  
      // width: 20%;
      .journeyTitle {
        padding-top:55%;
        color: rgb(255, 255, 255);
        font-size: 1.1em;
        text-shadow: #000000 0px 0px 6px;
        // font-weight: bold;
      }
      .journeyNum {
        padding-top:5%;
        color: rgb(251, 255, 6);
        font-size: 2.2em;
        font-weight: bold;
        text-shadow: #000000 0px 0px 6px;
      }
      .journeyFooter {
        padding-top:6%;
        color: white;
        font-size: 1em;
        text-shadow: #000000 0px 0px 6px;
        // font-weight: bold;
      }
    }
  }

  .journeyFlex_S {
    margin:50px 5%;
    width:90%;
    flex-direction: row;
    justify-content: space-between;
    display: -webkit-flex; 
    display: flex;
    flex-wrap: wrap;

    .journeyItem {
      width:120px;
      height:155px;
      background-repeat: no-repeat;
      background-position: center;
      text-align: center;
      -moz-background-size: 100% 100%;  
      -o-background-size: 100% 100%;  
      -webkit-background-size: 100% 100%;  
      background-size: 100% 100%;  
      // width: 20%;
      .journeyTitle {
        padding-top:55%;
        color: rgb(255, 255, 255);
        font-size: 0.6em;
        text-shadow: #000000 0px 0px 6px;
        // font-weight: bold;
      }
      .journeyNum {
        padding-top:6%;
        color: rgb(251, 255, 6);
        font-size: 1.2em;
        font-weight: bold;
        text-shadow: #000000 0px 0px 6px;
      }
      .journeyFooter {
        padding-top:8%;
        color: white;
        font-size: 0.6em;
        text-shadow: #000000 0px 0px 6px;
        // font-weight: bold;
      }
    }
  }
}

#mainBox {
  display: flex;
  align-items: center;
  justify-content: center;
}

.forgetPsd1{
  margin: 0 auto;
  width: 453px;
  height: 58px;
  background: url("~@/assets/images/title.png") no-repeat center;
  font-size: 38px;
  font-weight: 700;
  text-align: center;
  line-height: 58px;
  color: #37c2e5;
  margin-top: 50px;
}

.signInBox {
  width: 480px;
  padding: 30px 50px 0;
  height: 360px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -290px;
  margin-top: 120px;
  text-align: center;
  padding-bottom: 100px;
}

.moreOption {
  font-size: 16px;
  color: #fff;
  padding: 10px 0 30px;
  span {
    text-decoration: underline;
    padding: 0 10px;
    cursor: pointer;
    &:nth-of-type(1) {
      float: left;
    }
    &:nth-of-type(2) {
      float: right;
    }
  }
}

.changeLangBtn {
  cursor: pointer;
  float: right;
  font-weight: normal;
  font-size: 18px;
  line-height: 60px;
}
.chooseLangUl {
  position: absolute;
  z-index: 111;
  li {
    height: 40px;
    cursor: pointer;
  }
}
.chooseLangUls {
  width: 100%;
  background: #0c355c;
  padding: 0 5px 10px 5px;
  border-radius: 5px;
}
.settingBtn,
.changeLangBtn {
  cursor: pointer;
  float: right;
  font-weight: normal;
  font-size: 18px;
  padding-right: 20px;
}
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px white inset;
  box-shadow: 0 0 0 1000px white inset;
}
.table {
  width: 80%;
  margin: 20px auto;
  border-radius: 40px;
  position: relative;
  /deep/ .el-table {
    border-radius: 15px;
    padding: 15px;
    border: 5px #39fff0 solid;
    background-color: #002b46;
    /deep/ th,
    /deep/ tr {
      background-color: #0c355c !important;
      td {
        border-bottom: 1px solid #002b46;
      }
      &:hover {
        background-color: #0c355c !important;
      }
      i {
        font-size: 20px;
        color: #fff;
      }
      div,
      span {
        color: #39fff0;
        font-size: 15px;
        letter-spacing: 1px;
      }
    }
    /deep/ th {
      border-bottom: 1px solid #002b46;
      div {
        color: #fff;
        letter-spacing: 2px;
        font-size: 16px;
      }
    }
  }
  .lfooter {
    width: 85px;
    height: 86px;
    background: url("~@/assets/images/lfooter.png") no-repeat center;
    background-size: cover;
    position: absolute;
    left: -15px;
    bottom: -10px;
  }
  .rfooter {
    width: 85px;
    height: 86px;
    background: url("~@/assets/images/rfooter.png") no-repeat center;
    background-size: cover;
    position: absolute;
    right: -15px;
    bottom: -10px;
  }
}
.table {
  /deep/ .el-table {
    &::before {
      height: 0;
    }
    .el-table__header-wrapper {
      border-top-left-radius: 15px;
      border-top-right-radius: 15px;
    }
    .el-table__body-wrapper {
      border-bottom-left-radius: 15px;
      border-bottom-right-radius: 15px;
    }
  }
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #0c355c;
}
.settingBtn,
.changeLangBtn {
  cursor: pointer;
  float: right;
  font-weight: normal;
  font-size: 18px;
  padding-right: 20px;
}
.settingBtn {
  padding-right: 0px;
  margin-right: 20px;
  position: relative;
  line-height: 60px;
  min-width: 135px;
  text-align: center;
}
.actSign {
  float: right;
  margin-right: 40px;
  width: 160px;
  height: 39px;
  margin-top: 12px;
  background: url("~~@/assets/images/up.png") no-repeat center;
  background-size: cover;
  cursor: pointer;
}
.actSignEn {
  background: url("~~@/assets/images/enUp.png") no-repeat center;
  background-size: cover;
}
.chooseLangUl {
  position: absolute;
  z-index: 111;
  li {
    height: 40px;
    cursor: pointer;
  }
}
.prize {
  position: fixed;
  top: 100px;
  left: 20px;
  z-index: 3;
}
/deep/ .el-table th,
/deep/ .el-table tr {
  background-color: #0c355c !important;
  td {
    border-bottom: 1px solid #002b46;
  }
  i {
    font-size: 20px;
    color: #fff;
  }
  div,
  span {
    color: #39fff0;
    font-size: 15px;
    letter-spacing: 1px;
  }
}
/deep/ .el-table th {
  border-bottom: 1px solid #002b46;
  div {
    color: #fff;
  }
}
.over {
  width: 725px;
  height: 467px;
  position: absolute;
  top: 20%;
  background: url("~@/assets/images/timeout.png") no-repeat 1px 2px;
  left: 50%;
  transform: translateX(-50%);
}
.over1 {
  width: 564px;
  height: 458px;
}
.bgiOver {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1000;
}
.timeout01 {
  width: 184px;
  height: 58px;
  position: absolute;
  top: 21px;
  left: 191px;
  z-index: 1;
  text-align: center;
  line-height: 58px;
  color: #fff;
  font-size: 24px;
  font-weight: 700;
}
.timeout02 {
  width: 500px;
  height: 200px;
  position: absolute;
  top: 100px;
  left: 30px;
  text-align: center;
  line-height: 200px;
  color: #fff;
  font-size: 19px;
  font-weight: 700;
}
.timeout03 {
  width: 100px;
  height: 40px;
  position: absolute;
  top: 354px;
  left: 69px;
  text-align: center;
  line-height: 40px;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  font-weight: 700;
}
.timeout04 {
  width: 100px;
  height: 40px;
  position: absolute;
  top: 354px;
  left: 400px;
  text-align: center;
  line-height: 40px;
  color: #fff;
  font-size: 23px;
  cursor: pointer;
  font-weight: 700;
}
img {
  vertical-align: middle;
}

.tables {
  height: 50px;
  width: 80%;
  margin: 50px auto 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ohcBtn {
  cursor: pointer;
  float: right;
}

/deep/ .el-switch.is-checked .el-switch__core::after {
  margin-left: -27px;
}
/deep/ .el-switch__label.is-active span {
  color: #ffec44 !important;
}
/deep/ .el-loading-mask {
  z-index: 1;
}
/deep/ .el-switch {
  height: 100%;
  .el-switch__label {
    span {
      font-size: 24px;
      color: #00ffff;
    }
  }
  /deep/ .el-switch__core {
    border-color: #00ffff;
    background-color: #002b46;
    width: 60px !important;
    height: 30px;
    border-radius: 20px;
    &::after {
      width: 25px;
      height: 25px;
      background-color: #00ffff;
    }
  }
}
/deep/ .el-icon-download {
  position: relative;
  z-index: 11;
}


// 多语言模块
.en, .he {
  .app11 { 
    background: url("~@/assets/images/homeEn.jpg") no-repeat center center; 
    background-size: cover;
    height: 100%;
    width: 100%;
    position: relative;
  }
}

.zh {
  .app11 { 
    background: url("~@/assets/images/homeZh.jpg") no-repeat center center; 
    background-size: cover;
    height: 100%;
    width: 100%;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/myPage.vue